import { useCallback } from 'react'

import { modalEnum } from 'components/modals/v2/modal'
import { useModalContext } from 'hooks/use_context'

const useSubmitRetryPaymentModal = (swipecastJobId, selectedPM, onRetryPayment, getPaymentMethodDisabled) => {
  const { onOpenModal } = useModalContext()

  // setup intent has only payment method id, so we can't pass the whole object
  const handleSubmitPM = useCallback(
    (paymentMethodId) => {
      if (!onRetryPayment || !paymentMethodId || !swipecastJobId) {
        return console.error('cannot submit payment modal: missing required parameters')
      }

      onRetryPayment(swipecastJobId, paymentMethodId)
    },
    [swipecastJobId, onRetryPayment]
  )

  const handleOpenCardModal = useCallback(() => {
    onOpenModal(modalEnum.addCard, { onAddCard: handleSubmitPM })
  }, [handleSubmitPM, onOpenModal])

  return useCallback(() => {
    if (!selectedPM) return
    if (selectedPM === 'new-card') return handleOpenCardModal()

    // Prevent submitting disabled payment methods
    if (getPaymentMethodDisabled && getPaymentMethodDisabled(selectedPM)) return

    handleSubmitPM(selectedPM.stripe_payment_method_id)
  }, [selectedPM, handleSubmitPM, handleOpenCardModal, getPaymentMethodDisabled])
}

export default useSubmitRetryPaymentModal
